var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 67,
    viewBox: "0 0 73 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2511 53.5839C23.2253 52.3947 20.619 53.0728 19.4297 55.0986C18.2405 57.1244 18.9186 59.7307 20.9444 60.9199C22.9702 62.1092 25.5765 61.431 26.7658 59.4052C27.955 57.3795 27.2769 54.7732 25.2511 53.5839Z",
    fill: "#3897FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2176 15.0005L29.6364 22.3762L35.2159 27.2183L27.8402 27.637L22.9982 33.2166L22.579 25.841L16.9999 20.9988L24.3756 20.5801L29.2176 15.0005Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9334 23.9557L61.3471 29.8797L68.6711 30.8464L62.7466 35.26L61.7804 42.584L57.3667 36.6599L50.0428 35.6933L55.9666 31.2798L56.9334 23.9557Z",
    fill: "#00A98F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSparkles);
export default __webpack_public_path__ + "static/media/left-sparkles.9cc7b254941828717c113e8d65ec26cb.svg";
export { ForwardRef as ReactComponent };